import { bbStart } from '/bb/index.js';
import { attachBbAutoSave, detachBbAutoSave } from './auto-save.js';
import { setAttributesMode } from '/bb/attributes-config.js';
import { normalizeBbOptions } from './config.js';
import {
  addBbWarning,
  setBbApiHost,
  setBbAppId,
  setBbAuto,
  setBbDebugUi,
  setBbEnabled,
  setHoldSubmitTimeoutMs,
} from './integration-state.js';

/**
 * Apply BB options from the first successful rsSDK('config', ...).
 *
 * @param {{ rsSDK: Function, options: object, appId?: string }} api
 */
export function applyBbFromConfig({ rsSDK, options, appId }) {
  const bb = normalizeBbOptions(options && options.bb);
  const endpoints = options && options.endpoints;
  const debug = !!(options && options.debug);

  setBbEnabled(bb.enabled);
  setBbAuto(bb.auto);
  setBbAppId(appId || '');
  setBbDebugUi(debug);
  setAttributesMode(bb.attributesMode);
  setHoldSubmitTimeoutMs(bb.holdSubmitTimeoutMs);
  setBbApiHost(endpoints && endpoints.length ? endpoints[0] : rsSDK.defaultEndpoint || '');

  bb.warnings.forEach(function (warning) {
    addBbWarning(warning);
  });

  if (!bb.enabled) {
    detachBbAutoSave();
  } else {
    bbStart();
    if (bb.auto) {
      attachBbAutoSave();
    } else {
      detachBbAutoSave();
    }
  }

  if (typeof __BB_DEVTOOLS__ !== 'undefined' && __BB_DEVTOOLS__ && debug) {
    try {
      const hook = typeof window !== 'undefined' ? window.__RS_BB_DEVTOOLS_MOUNT__ : null;
      if (typeof hook === 'function') hook();
    } catch (e) {
      /* ignore */
    }
  }
}
